
const newModel = () => {
    return {
        cosoDuocId: null,
        ten: null,
        chuCoSo: null,
        trinhdochuyenmonCosoduocId: null,
        tenTrinhdochuyenmonCosoduoc: null,
        tenPhuongXa: null,
        phuongXaId: null,
        diaChi: null,
        nhanVien: null,
        ngayThucHanh: null,
        trinhDoNhanVien: null,
        gpsLong: null,
        gpsLat: null,
        soGcn: null,
        hinhthuckinhdoanhCosoduocId: null,
        tenHinhthuckinhdoanhCosoduoc: null,
        ngayCapGcn: null,
        ghiChu: null,
        stt: null,
        enabled: null,
        dateCreated: null,
        userCreated: null,
        dateModified: null,
        userModified: null,
        isDeleted: null,
        userDeleted: null,
        dateDeleted: null,
        tenUserCreated: null,
        tenUserModified: null,
        tenUserDeleted: null
    }
}

const newFEModel = () => {
    return {
        cosoDuocId: null,
        ten: null,
        chuCoSo: null,
        trinhdochuyenmonCosoduocId: null,
        tenTrinhdochuyenmonCosoduoc: null,
        tenPhuongXa: null,
        phuongXaId: null,
        diaChi: null,
        nhanVien: null,
        ngayThucHanh: null,
        trinhDoNhanVien: null,
        gpsLong: null,
        gpsLat: null,
        soGcn: null,
        hinhthuckinhdoanhCosoduocId: null,
        tenHinhthuckinhdoanhCosoduoc: null,
        ngayCapGcn: null,
        ghiChu: null,
        stt: "0",
        enabled: true,
    }
}

const fromJson = (item) => {
    return {
        cosoDuocId: item.cosoDuocId,
        ten: item.ten,
        chuCoSo: item.chuCoSo,
        trinhdochuyenmonCosoduocId: item.trinhdochuyenmonCosoduocId,
        tenTrinhdochuyenmonCosoduoc: item.tenTrinhdochuyenmonCosoduoc,
        tenPhuongXa: item.tenPhuongXa,
        phuongXaId: item.phuongXaId,
        diaChi: item.diaChi,
        nhanVien: item.nhanVien,
        ngayThucHanh: item.ngayThucHanh,
        trinhDoNhanVien: item.trinhDoNhanVien,
        gpsLong: item.gpsLong,
        gpsLat: item.gpsLat,
        soGcn: item.soGcn,
        hinhthuckinhdoanhCosoduocId: item.hinhthuckinhdoanhCosoduocId,
        tenHinhthuckinhdoanhCosoduoc: item.tenHinhthuckinhdoanhCosoduoc,
        ngayCapGcn: item.ngayCapGcn,
        ghiChu: item.ghiChu,
        stt: item.stt,
        enabled: item.enabled,
        dateCreated: item.dateCreated,
        userCreated: item.userCreated,
        dateModified: item.dateModified,
        userModified: item.userModified,
        isDeleted: item.isDeleted,
        userDeleted: item.userDeleted,
        dateDeleted: item.dateDeleted,
        tenUserCreated: item.tenUserCreated,
        tenUserModified: item.tenUserModified,
        tenUserDeleted: item.tenUserDeleted
    }
}

const parseModeltoFEModel = (item) => {
    return {
        cosoDuocId: item.cosoDuocId,
        ten: item.ten,
        chuCoSo: item.chuCoSo,
        trinhdochuyenmonCosoduocId: item.trinhdochuyenmonCosoduocId,
        phuongXaId: item.phuongXaId,
        diaChi: item.diaChi,
        nhanVien: item.nhanVien,
        ngayThucHanh: item.ngayThucHanh,
        trinhDoNhanVien: item.trinhDoNhanVien,
        gpsLong: item.gpsLong,
        gpsLat: item.gpsLat,
        hinhthuckinhdoanhCosoduocId: item.hinhthuckinhdoanhCosoduocId,
        soGcn: item.soGcn,
        ngayCapGcn: item.ngayCapGcn,
        stt: item.stt,
        ghiChu: item.ghiChu,
        enabled: item.enabled,
    }
}

const errors = () => {
    return {
        cosoDuocId: null,
        ten: null,
        chuCoSo: null,
        trinhdochuyenmonCosoduocId: null,
        phuongXaId: null,
        diaChi: null,
        nhanVien: null,
        ngayThucHanh: null,
        trinhDoNhanVien: null,
        gpsLong: null,
        gpsLat: null,
        hinhthuckinhdoanhCosoduocId: null,
        soGcn: null,
        ngayCapGcn: null,
        ghiChu: null,
        stt: null,
        enabled: null,
    }
}

const newPagingSearchModel = () => {
    return {
        pageNumber: null,
        pageSize: null,
        sort: null,
        ten: null,
        chuCoSo: null,
        trinhdochuyenmonCosoduocId: null,
        phuongXaId: null,
        hinhthuckinhdoanhCosoduocId: null,
        soGcn: null,
        ngayCapGcn: null,
        enabled: null,
    }
}

const newSearchModel = () => {
    return {
        ten: null,
        chuCoSo: null,
        trinhdochuyenmonCosoduocId: null,
        phuongXaId: null,
        hinhthuckinhdoanhCosoduocId: null,
        soGcn: null,
        ngayCapGcn: null,
        enabled: null,
    }
}

export const coSoDuocModel = {
    newModel,
    newFEModel,
    parseModeltoFEModel,
    newPagingSearchModel,
    newSearchModel,
    fromJson,
    errors,
}
